export const REQUESTOR = "banner-wrapper";
export const PROD_API_ENDPOINT = "https://category-page-v3-bff-cdn.prod.merch.vpsvc.com";
export const DEV_API_ENDPOINT = "https://category-page-v3-bff-cdn.sandbox.merch.vpsvc.com";
